import {useRouter} from 'next/router';
import React, {FC, MouseEvent, useCallback, useContext, useMemo} from 'react';
import classNames from 'classnames';
import style from 'modules/events/components/FilterTastingHall/style.module.scss';
import {Typography} from 'components/Typography';
import Icon from 'components/Icon';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {showModal} from 'modules/modals/thunks';
import {MODALS} from 'modules/modals/constants';
import {EventsListContext} from 'modules/events/context';

interface IQuery {
    hall: number;
}

export const FilterTastingHall: FC = () => {
    const {isLoading} = useContext(EventsListContext);

    const router = useRouter();
    const dispatch = useAppDispatch();

    const isActive = useMemo(() => {
        return Boolean(router.query.hall);
    }, [router]);

    const handleApplyFilter = useCallback(
        (queryData: IQuery | null) => {
            const {pathname, query} = router;
            const {hall, page, ...restParams} = query;

            router.push(
                {
                    pathname,
                    query: {...restParams, ...queryData},
                },
                undefined,
                {shallow: true},
            );
        },
        [router],
    );

    const handleClick = useCallback(() => {
        let query = null;

        if (!isActive) {
            query = {
                hall: 1,
            };
        }

        handleApplyFilter(query);
    }, [handleApplyFilter, isActive]);

    const onInfoIconClick = useCallback(
        (event: MouseEvent<HTMLElement>) => {
            event.stopPropagation();
            dispatch(showModal(MODALS.EVENT_HALL_INFO.name));
        },
        [dispatch],
    );

    return (
        <button
            className={classNames(style.main, {[style.isActive]: isActive, [style.isDisabled]: isLoading})}
            onClick={handleClick}
            type={'button'}
        >
            <Typography variant={'label-14-m'}>Дегустационный зал</Typography>
            <div onClick={onInfoIconClick}>
                <Icon className={style.icon} icon={'hint-new'} />
            </div>
        </button>
    );
};
